import { Translation } from 'cng-common/features/translations/components/translation'

import { IJBPMAP } from '../../../../models/IJBPPMAP'
import { IS_SHOW_PREV_PREV_FYEAR, PLANNING_BY_FY_FQ } from '../../../config'
import { getMapValueStandard } from '../../helpers/getMapValueStandard'
import { isMapDataPresentStandard } from '../../helpers/isMapDataPresentStandard'

import styles from './MapRowStandard.module.scss'

interface IProps {
  mapData: IJBPMAP[]
  fyear: number
  currentCat: string
  tag: string
  isShowCalcActuals: boolean
  isShowFutureYears: boolean
  isComposedReport: boolean
  isUnits?: boolean
  isTotal?: boolean
  hideIfEmpty?: boolean
}

export const MapRowStandard = ({
  mapData,
  fyear,
  currentCat,
  tag,
  isShowCalcActuals,
  isShowFutureYears,
  isComposedReport,
  isUnits = false,
  isTotal = false,
}: IProps) => {
  const isShowPrePreYear = IS_SHOW_PREV_PREV_FYEAR && !isComposedReport && !isTotal
  const yearlyColSpan = 3 + (isShowPrePreYear ? 1 : 0) + (isShowCalcActuals ? 1 : 0)
  const isDataPresent = isMapDataPresentStandard(mapData, fyear, currentCat, isUnits)

  return !isDataPresent ? (
    <></>
  ) : (
    <tr>
      <th colSpan={yearlyColSpan} className={styles.guidance}>
        <Translation text={tag} span actionsInside />
      </th>
      <th colSpan={1}>
        {getMapValueStandard(mapData, fyear, currentCat, PLANNING_BY_FY_FQ, isUnits)}
      </th>
      <th></th>
      <th colSpan={2}>{getMapValueStandard(mapData, fyear, currentCat, 1, isUnits)}</th>
      <th></th>
      <th colSpan={2}>{getMapValueStandard(mapData, fyear, currentCat, 2, isUnits)}</th>
      <th></th>
      <th colSpan={2}>{getMapValueStandard(mapData, fyear, currentCat, 3, isUnits)}</th>
      <th></th>
      <th colSpan={2}>{getMapValueStandard(mapData, fyear, currentCat, 4, isUnits)}</th>
      <th></th>
      {isShowFutureYears && <th colSpan={4}></th>}
    </tr>
  )
}
